module.exports = __webpack_public_path__ + "img/商品详情-4.6725ce9a.png";